import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { FlashMessagesService } from 'flash-messages-angular';
import { FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';
import { RouteService } from 'src/app/core/services';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-admin-account-info',
  templateUrl: './admin-account-info.component.html',
  styleUrls: ['./admin-account-info.component.css']
})
export class AdminAccountInfoComponent implements OnInit {

  // Initialize form
  form = this.fb.group({
    email:     [''],
    firstName: ['', [Validators.required]],
    lastName:  ['', [Validators.required]],
  });

  get user() { return this.form.value; }
  get email() { return this.form.controls.email as FormControl; }
  get firstName() { return this.form.controls.firstName as FormControl; }
  get lastName() { return this.form.controls.lastName as FormControl; }

  // Template variables
  userLoaded = false;
  resetMode = false;
  isActiveDiv = false;

  constructor(private auth: AuthService, private adminService: AdminService, private routeService: RouteService, private flashMessage: FlashMessagesService, private fb: FormBuilder) { }

  // When the page is loaded, pull the profile information
  ngOnInit(): void {
    // Use auth service to send request
    this.adminService.getProfile().toPromise().then(({ user }: any) => {
      // Assign response to user object
      this.form.setValue({
        email:     user.email     || '',
        firstName: user.firstName || '',
        lastName:  user.lastName  || '',
      });

      this.userLoaded = true;
    });
  }

  // Update profile information
  onUpdate(f: NgForm) {

    // Update user profile with information
    if (this.form.valid) {
      // Update user in local storage
      this.auth.user = { ...this.auth.user,
        name: `${this.user.firstName || ''} ${this.user.lastName || ''}`.trim(),
      };

      this.auth.updateUserDataStored();

      this.adminService.updateSelf(this.user).toPromise().then((res: any) => {
        // Successfully updated
        if (res.success) {
          // Display update success to user
          this.flashMessage.show("Account updated.", {
            cssClass: 'alert-success',
            timeout: 5000
          });

          this.routeService.scrollToTop();

          // Reset submitted status to clear validation errors
          f.resetForm(this.user);
        }
      });
    }
  }
}
